import request from '@/request'
import { PAYMENT } from '@/data/api'
import { bindVar } from '@/util'

export default {
  namespaced: true,
  state: {
    paymentData: '',
    paymentStatus: '',
    plans: '',
    transactions: ''
  },
  getters: {
    paymentData: state => state.paymentData,
    paymentStatus: state => state.paymentStatus,
    plans: state => state.plans,
    transactions: state => state.transactions
  },
  mutations: {
    setPaymentData (state, paymentData) {
      state.paymentData = paymentData
    },
    setPaymentStatus (state, paymentStatus) {
      state.paymentStatus = paymentStatus
    },
    setPlans (state, plans) {
      state.plans = plans
    },
    setTransactions (state, transactions) {
      state.transactions = transactions
    }
  },
  actions: {
    async getPlans ({ commit }) {
      try {
        const { data } = await request.get(`${PAYMENT.PLANS}`)
        commit('setPlans', data)
      } catch (e) {
        commit('setPlans', '')
      }
    },
    async subscribe ({ commit }, params) {
      try {
        const { data } = await request.post(PAYMENT.SUBSCRIPTION, params)
        commit('setPaymentData', data)
      } catch (e) {
        commit('setPaymentData', '')
      }
    },
    async cancelPlan () {
      try {
        await request.get(`${PAYMENT.CANCEL}`)
      } catch (e) {
        throw e
      }
    },
    async getTransactions ({ commit }) {
      try {
        const { data } = await request.get(`${PAYMENT.TRANSACTION}`)
        commit('setTransactions', data.data)
      } catch (e) {
        commit('setTransactions', '')
      }
    },
    async invoiceGenerate (context, orderId) {
      try {
        const { data } = await request.get(bindVar(PAYMENT.INVOICE, { orderId }), {
          responseType: 'arraybuffer',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
          },
          timeout: 1000 * 300
        })
        return data
      } catch (e) {
        throw e
      }
    }
  }
}
